import { Product } from "domain/classes/product.class";
import { BoxAccidentToolbarController } from "../boxAccident-toolbar.controller";
import { BoxAccidentJournalController } from "../journal/boxAccidentJournal.controller";
import { BoxAccidentJournalToolbarController } from "../journal/boxAccidentJournalToolbar.controller";
import { SafeCarAccidentController } from "./safeCarAccident.controller";
import { SafeCarAccidentContractDTO } from "./safeCarAccident.factory";

import "../components/ugsk-box-accident-contract-params/ugskBoxAccidentContractParams.component";
import "../components/ugsk-box-accident-insurance-conditions/ugskBoxAccidentInsuranceConditions.component";
import "../components/ugsk-box-accident-insured-person/ugskBoxAccidentInsuredPerson.component";

import angular from "angular";
import { ProductsService } from "infrastructure/services/products.service";
import ugskBoxAccidentInsurant from "../components/ugsk-box-accident-insurant/ugskBoxAccidentInsurant.component";
import template from "./body.html";
import safeCarVehicleParamsComponent from "./components/ugsk-vehicle-params/ugskVehicleParams.component";
import manual from "./manual_safeCarAccident.pdf";

export class SafeCarAccident extends Product {
    constructor() {
        super();
        this.code = "safeCarAccident";
        this.groupName = "Страхование жизни и здоровья";
        this.productName = "Безопасный автомобиль";
        this.description = "Добровольное страхование от несчастных случаев и болезней";
        this.insuranceRules = {
            base: "https://ugsk.ru/about/pravila/NS.pdf",
        };
        this.insurerCanBeLegalEntity = true;
        this.logo = "nav_personalAccident";
        this.manualUrl = manual;
        this.sort = 150;
        this.template = template;
        this.controller = SafeCarAccidentController;
        this.toolbarController = BoxAccidentToolbarController;
        this.journalController = BoxAccidentJournalController;
        this.journalToolbarController = BoxAccidentJournalToolbarController;
        this.extraViews = {
            "contractParams@app.safeCarAccident.index": {
                template: require("./view.contractParams.html"),
            },
            "insuranceConditions@app.safeCarAccident.index": {
                template: require("./view.insuranceConditions.html"),
            },
            "insurant@app.safeCarAccident.index": {
                template: require("../view.insurantBase.html"),
            },
            "insuredPerson@app.safeCarAccident.index": {
                template: require("./view.insuredPerson.html"),
            },
            "payment@app.safeCarAccident.index": {
                template: require("../view.paymentBase.html"),
            },
            "vehicleParams@app.safeCarAccident.index": {
                template: require("./view.vehicleParams.html"),
            },
        };
    }
    get contractClass() {
        return SafeCarAccidentContractDTO;
    }
}

angular.module("app.safeCarAccident", [
    "touchSpin",
    "app.boxAccident.components.contract-params",
    "app.boxAccident.components.insurance-conditions",
    "app.boxAccident.components.insured-person",
    safeCarVehicleParamsComponent,
    ugskBoxAccidentInsurant,
]).run((productsService: ProductsService) => {
    "ngInject";

    productsService.register(new SafeCarAccident());
});
